import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium leading-[18px] [&_svg]:size-3 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        outline: "border-border bg-card text-body",
        success: "border-transparent bg-pastel-mint text-pastel-mint-ink",
        warning: "border-transparent bg-pastel-peach text-pastel-peach-ink",
        destructive: "border-transparent bg-pastel-rose text-pastel-rose-ink",
        info: "border-transparent bg-pastel-sky text-pastel-sky-ink",
        muted: "border-transparent bg-muted text-muted-foreground",
        lavender: "border-transparent bg-pastel-lavender text-pastel-lavender-ink",
        lilac: "border-transparent bg-pastel-lilac text-pastel-lilac-ink",
      },
    },
    defaultVariants: {
      variant: "secondary",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {
  /** Leading status dot in the badge's colour. */
  dot?: boolean;
}

function Badge({ className, variant, dot, children, ...props }: BadgeProps) {
  return (
    <span data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props}>
      {dot && <span className="size-1.5 rounded-full bg-current" aria-hidden />}
      {children}
    </span>
  );
}

export { Badge, badgeVariants };
